<script>
export default {
  name: "sellOrderRulesForm",
  props: {
    cityData: {
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      disabled: true,
      form: {
        status: 2,
        refundRulesJson: [
          {
            timeType: 1,
            timeNum: "",
            refundFee: "",
          },
        ],
      },
      loading: false
    };
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
  },
  watch: {
    cityData: {
      handler(newval) {
        this.initFn();
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    initFn() {
      if (!this.cityData.cityCode) {
        return
      }
      console.log('this.cityData', this.cityData)
      const url = "/api/v1/manage/hitchRide/refundRule";
      this.$axios.get(url, {
        cityCode: this.cityData.cityCode
      }).then(({ code, data }) => {
        if (code === 1 && data) {
          this.form = {
            ...this.form,
            ...data,
            refundRulesJson: data.refundRulesJson
              ? JSON.parse(data.refundRulesJson)
              : [
                {
                  timeType: 1,
                  timeNum: "",
                  refundFee: "",
                },
              ],
          };
        }
      });
    },

    submitForm() {
      this.$refs.form.validate().then(async (valid) => {
        this.loading = true;
        const url = "/api/v1/manage/hitchRide/refundRule";
        const data = await this.$axios.post(url, {
          organizationId: this.mixinUserInfo.organizationId,
          status: this.form.status,
          refundRulesJson: JSON.stringify(this.form.refundRulesJson),
          cityCode: this.cityData.cityCode,
        });
        this.loading = false;
        if (data.code === 1) {
          this.$message.success("保存成功");
          this.disabled = true;
        }
      });
    },

    cancelEdit() {
      this.initFn();
      this.disabled = true;
    },
    addClick() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.form.refundRulesJson.push({
            timeType: 1,
            timeNum: "",
            refundFee: "",
          });
        } else {
          return false;
        }
      });
    },
    removeClick(index) {
      this.form.refundRulesJson.splice(index, 1);
    },
    calculateMinutes(item) {
      return item.timeType === 1
        ? Number(item.timeNum) * 60
        : Number(item.timeNum);
    },
    /**
     * 验证器
     */
    validateTimeNum(rule, value, callback) {
      let arr = rule.fullField.split(".");

      let i = Number(arr[1]);

      let item = this.calculateMinutes(this.form.refundRulesJson[i]);
      let prevItem =
        i > 0 ? this.calculateMinutes(this.form.refundRulesJson[i - 1]) : null;
      let nextItem = this.form.refundRulesJson[i + 1]
        ? this.calculateMinutes(this.form.refundRulesJson[i + 1])
        : null;
      if (i > 0 && prevItem && item >= prevItem) {
        callback(new Error("请小于上一项规则的时间"));
      } else if (i < 5 && nextItem && item <= nextItem) {
        callback(new Error("请大于下一项规则的时间"));
      } else {
        callback();
      }
    },
  },
};
</script>

<template>
  <div class="sellOrderRulesForm" style="width: 800px;">
    <div class="flex-between">
      <div class="formTitle">销单规则</div>
      <template v-if="btnPreFn(routeName + '_edit', false)">
        <el-button type="primary" v-if="disabled" @click="disabled = false">编辑</el-button>
        <div v-else>
          <el-button @click="cancelEdit">取消</el-button>
          <el-button type="primary" @click="submitForm" :loading="loading">保存</el-button>
        </div>
      </template>
    </div>
    <el-form :model="form" ref="form" :disabled="disabled">
      <el-form-item style="margin-bottom: 15px">
        <div class="flex-start">
          <el-switch v-model="form.status" :active-value="1" :inactive-value="2"></el-switch>
          <span class="util-remark tips">如关闭，则乘客取消订单时不收取取消费用</span>
        </div>
      </el-form-item>
      <el-form-item>
        <div class="flex-start rulesItem" v-for="(item, index) in form.refundRulesJson" :key="index">
          <el-form-item 
            label="" 
            :prop="'refundRulesJson.' + index + '.timeNum'"
            :rules="[
              { required: form.status == 1 ? true : false, message: '请输入数字' }, 
              { validator: validateTimeNum, trigger: 'blur' },
            ]"
            style="width: 240px; flex-shrink: 0;"
          >
            <el-input v-model="item.timeNum" v-input-filter="{ min: 0, max: 100, precision: 2 }" :controls="false">
              <template slot="prepend">出发时间前</template>
            </el-input>
          </el-form-item>
          <el-form-item label="" :prop="'refundRulesJson.' + index + '.timeType'"  style="width: 80px; margin-left: 8px; flex-shrink: 0;">
            <el-select v-model="item.timeType">
              <el-option label="小时" :value="1"></el-option>
              <el-option label="分钟" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="" :prop="'refundRulesJson.' + index + '.refundFee'"
            :rules="[{ required: form.status == 1 ? true : false, message: '请输入数字' }]" style="width: 464px; flex-shrink: 0; margin-left: 8px;">
            <el-input v-model="item.refundFee" v-input-filter="{ min: 0, max: 100, precision: 2 }">
              <template slot="prepend">内取消订单，按支付金额</template>
              <template slot="append">%收取取消费</template>
            </el-input>
          </el-form-item>
          <div style="margin-left: 8px;">
            <el-button v-if="index !== 0 && !disabled" style="color: red; border-color: red;"
              @click="removeClick(index)">删除</el-button>
          </div>
        </div>
      </el-form-item>
      <el-button size="large" style="width: 100%; border-style: dashed; color: #606266;"
        v-if="!disabled && form.refundRulesJson.length < 5" @click="addClick">
        添加取消规则（还可添加{{ 5 - form.refundRulesJson.length }}个）
      </el-button>
    </el-form>
  </div>
</template>

<style scoped lang="less">
.sellOrderRulesForm {


  .tips {
    margin-left: 10px;
  }

  .rulesItem {
    margin-bottom: 15px;
  }

  /deep/ .el-form-item {
    margin-bottom: 0;
  }

  /deep/ .el-input-group__append,
  .el-input-group__prepend {
    background-color: #F5F7FA !important;
  }
  /deep/ .el-input-group .el-input__inner{
    border-right: 1px solid #DCDFE6 !important;
  }
}
</style>